<template>
  <div>
    <div class="breadcrumbs"></div>
    <PageTitle pageHeading="Reports" :rightsideButton="false"> </PageTitle>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
export default {
  name: "ReportView",
  components: {
    PageTitle,
  },
  mounted() {},
};
</script>
